import { z } from "zod/v4";

export const BulkUploadDataRequestBodySchema = z.object({
  start: z.number(),
  end: z.number(),
});

export type BulkUploadDataRequestBodyType = z.infer<
  typeof BulkUploadDataRequestBodySchema
>;
